export function openPlatformAuthModal(mode) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent('c7:auth:open', { detail: { mode } }));
}

export function openLoginModal() {
  openPlatformAuthModal('login');
}

export function openSignupModal() {
  openPlatformAuthModal('signup');
}

